"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryTag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cbfed8c3a{box-sizing:border-box;padding:.1875rem .4375rem;font-size:.875rem;font-weight:400;line-height:1rem;max-width:100%;border-radius:.125rem;display:inline-flex}.c54c5f6e3{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.c9f95cf03{color:var(--color-flomni-blue-70);background:rgba(226,233,249,.8);border:1px solid rgba(70,118,217,.4)}.c07afdfb3{color:var(--color-flomni-green-70);background:rgba(238,250,219,.8);border:1px solid rgba(116,186,0,.4)}.cff60fa6d{color:var(--color-flomni-rose-70);background:rgba(244,236,250,.8);border:1px solid rgba(196,70,217,.4)}.cd49454c7{color:#f8c210;background:rgba(249,243,226,.8);border:1px solid rgba(248,194,16,.4)}.c4ea6b3b7{color:var(--color-flomni-gray-70);background:rgba(202,207,213,.2);border:1px solid rgba(123,136,149,.4)}.ccafd536f{color:var(--color-flomni-gray-70);background:rgba(202,207,213,.2);border:1px solid rgba(123,136,149,.4)}");
var styles = {
  root: 'cbfed8c3a',
  inner: 'c54c5f6e3',
  '--view-action': 'c9f95cf03',
  '--view-success': 'c07afdfb3',
  '--view-warning': 'cff60fa6d',
  '--view-bright': 'cd49454c7',
  '--view-cancel': 'c4ea6b3b7',
  '--disabled': 'ccafd536f'
};

var PrimaryTag = function PrimaryTag(props) {
  var view = props.view,
      children = props.children,
      disabled = props.disabled,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view], (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.inner
  }, children));
};

exports.PrimaryTag = PrimaryTag;
var view = ['action', 'success', 'warning', 'bright', 'cancel'];
PrimaryTag.modes = {
  view: view
};
PrimaryTag.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryTag.defaultProps = {
  disabled: false,
  view: 'action',
  classes: {}
};